import __vue_normalize__ from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './FormItem.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"b24-form-item",class:_vm.rootClass},[_c('div',{staticClass:"b24-form-item__wrap"},[(_vm.label || _vm.showPassword)?_c('label',{staticClass:"b24-form-item__label",attrs:{"for":_vm.nativeId}},[(_vm.label)?_c('span',{staticClass:"b24-form-item__label-text",class:{'_bold': _vm.isBoldLabel}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.showPassword)?_c('button',{staticClass:"b24-form-item__password-control",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.handlePasswordVisible($event)}}},[(!_vm.passwordVisible)?_c('eye-icon',{staticClass:"b24-form-item__password-icon",attrs:{"width":16,"height":16}}):_c('eye-close-icon',{staticClass:"b24-form-item__password-icon",attrs:{"width":16,"height":16}}),_vm._v(" "),_c('span',{staticClass:"b24-form-item__password-text"},[_vm._v("\n          "+_vm._s(_vm.passwordHelpText)+"\n        ")])],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.textAfter && !_vm.showPassword)?_c('p',{staticClass:"b24-form-item__desc _after",domProps:{"innerHTML":_vm._s(_vm.textAfter)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"b24-form-item__container"},[_vm._t("default")],2),_vm._v(" "),_c('fade-transition',{attrs:{"duration":40}},[(_vm.textBefore || _vm.textError)?_c('p',{ref:"beforeText",staticClass:"b24-form-item__desc _before",domProps:{"innerHTML":_vm._s(_vm.beforeTextHelper)}}):_vm._e()])],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
